var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F44D(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcea2b",
    d: "M37.088 11.232l-2.922.645L19 29.21l-7.333 13.059 1.999 11.274 12.938 7.07 9.625-.041 14.042.208 2.395-1.57.75-3.833-.75-1.584 3.584-.083 1.333-1.667.833-2.333-1.583-3 1.583-.667 1.917-2.666-.917-2.75-2.5-1.167 1.167-2.167.167-3.416-2.584-1.5-13.166-.5-.834-.667-.854-.597h-9.125l.063-1.736 3.916-9.584 1.667-4.583z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35.236 59.6h-9c-8.321 0-14-6.68-14-15 .02-4.799 1.8-9.424 5-13M34.625 31.6h-4.389l7-18c.811-2.083-2.79-3.8-5-1l-15 19M37.448 35.1a3.786 3.786 0 004 3.5h13a3.531 3.531 0 100-7h-13a3.786 3.786 0 00-4 3.5zM38.305 56.437a3.786 3.786 0 004 3.5h7a3.531 3.531 0 100-7h-7a3.786 3.786 0 00-4 3.5zM33.236 42.437a3.786 3.786 0 004 3.5h19a3.531 3.531 0 100-7h-19a3.786 3.786 0 00-4 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35.236 49.437a3.786 3.786 0 004 3.5h15a3.531 3.531 0 100-7h-15a3.786 3.786 0 00-4 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M14.136 36.263a19.457 19.457 0 00-1.906 7.839c0 8.56 4.625 15.5 15.125 15.5"
  }))));
}
export default Svg1F44D;